import { z } from "zod";

export const getWarehouseZoneParamSchema = z.object({
	warehouseZoneId: z.uuid(),
});

export type GetWarehouseZoneParamSchema = z.infer<typeof getWarehouseZoneParamSchema>;
